export default "__VITE_ASSET__CJ4BjeWq__"